import { template as EventRescheduled } from './emails/event-rescheduled';
import { template as EventCanceled } from './emails/event-canceled';
import { template as PayoutCompleted } from './emails/event-payout-completed';
import { template as BatchPayoutCompleted } from './emails/batch-payout-completed';
import { template as CartAbandonment } from './emails/cart-abandonment';
import { template as EventCreated } from './emails/event-created';
import { template as EventReminder } from './emails/event-reminder';
import { template as OrderConfirmation } from './emails/order-confirmation';
import { template as RsvpConfirmation } from './emails/rsvp-confirmation';
import { template as TicketReport } from './emails/ticket-report';
import { template as WaitlistBuyOrderFulfilled } from './emails/waitlist-buy-order-fulfilled';
import { template as WaitlistCreateBuyOrder } from './emails/waitlist-create-buy-order';
import { template as WaitlistCreateSellOrder } from './emails/waitlist-create-sell-order';
import { template as WaitlistSellOrderFulfilled } from './emails/waitlist-sell-order-filled';
import { template as WaitlistOpened } from './emails/waitlist-opened';
import { TemplateVersion as NewCampaignTemplateVersion } from './emails/new-campaign';

const NewCampaign = NewCampaignTemplateVersion[1];
export {
  CartAbandonment,
  EventCreated,
  EventReminder,
  OrderConfirmation,
  RsvpConfirmation,
  TicketReport,
  WaitlistBuyOrderFulfilled,
  WaitlistCreateBuyOrder,
  WaitlistCreateSellOrder,
  WaitlistSellOrderFulfilled,
  WaitlistOpened,
  EventCanceled,
  PayoutCompleted,
  BatchPayoutCompleted,
  NewCampaign,
};

export const VersionedTemplates = {
  NewCampaign: NewCampaignTemplateVersion,
};

export enum EmailType {
  EventRescheduled = 'eventRescheduled',
  EventCancelled = 'eventCancelled',
  NewCampaign = 'newCampaign',
}

export const emails = {
  [EmailType.EventRescheduled]: {
    template: EventRescheduled,
    name: 'EventRescheduled',
  },
  ...Object.keys(NewCampaignTemplateVersion).map(version => ({
    [`NewCampaign-v${version}`]: {
      template: NewCampaignTemplateVersion[version],
      name: `NewCampaign-v${version}`,
    },
  })),
};
